// site screens' English text (D146). Keys start with "site.".
// The public pages: landing, About, Pricing, Request an invitation, and the
// header and footer around them. The privacy policy and terms stay English.
export const site = {
  // Header, footer and the bits every public page shares
  'site.nav.signIn': 'Sign in',
  'site.nav.openTwinden': 'Open Twinden',
  'site.nav.help': 'Help',
  'site.nav.about': 'About',
  'site.nav.pricing': 'Pricing',
  'site.nav.privacy': 'Privacy',
  'site.nav.terms': 'Terms',
  'site.nav.contact': 'Contact',
  'site.chipIn': 'Chip in',
  // The native apps' store badges (D344–D345)
  'site.stores.label': 'Get the Twinden app',
  'site.stores.appStoreAlt': 'Download Twinden on the App Store',
  'site.stores.playStoreAlt': 'Get Twinden on Google Play',
  'site.stores.apk': 'Download for Android (APK)',
  'site.stores.apkHint':
    'Your phone asks whether your browser may install apps: allow it for this download, then open the file to install Twinden.',
  'site.stores.worksBest': 'Twinden works best as an app on your phone.',
  'site.stores.legalApple':
    'Apple, the Apple logo and App Store are trademarks of Apple Inc., registered in the U.S. and other countries.',
  'site.stores.legalGoogle':
    'Google Play and the Google Play logo are trademarks of Google LLC.',
  'site.footer.anotherProject': 'Another project by {company}',
  // Contact Twinden (M58, D209)
  'site.footer.email': 'Write to us: {email}',
  'site.madeInIndia.title': 'Made in India.',
  'site.madeInIndia.body':
    'Built in Pune by {company}, for families everywhere.',
  'site.madeInIndia.footer': 'Made with vada pav and coffee in Pune, India',
  'site.flag.india': 'India',
  'site.link.privacyPolicy': 'privacy policy',
  'site.link.encryptionStrength': 'see Help',
  'site.policy.englishOnly': 'This page is in English for now.',

  // Landing page: hero
  'site.landing.hero.title': 'A private home for your family.',
  'site.landing.hero.body':
    'Chat, call, and keep the family’s lists, documents and links in one place. End-to-end encrypted, with no ads, no tracking and no passwords. Free for every family.',
  'site.landing.hero.inviteOnly':
    'Twinden is invite-only: someone in your family adds you, or {link}.',
  'site.landing.hero.inviteLink': 'request an invitation',

  // Landing page: the chat preview
  'site.landing.preview.group': 'Everyone',
  'site.landing.preview.members': '{count} people',
  'site.landing.preview.nani': 'Who’s coming on Sunday? Making biryani 🍲',
  'site.landing.preview.mine': 'Us! I’ll bring dessert',
  'site.landing.preview.arjun': 'Added “cardamom” to the shopping list',
  'site.landing.preview.encrypted': 'End-to-end encrypted',
  'site.landing.preview.label': 'Preview of a family chat in Twinden',
  'site.landing.preview.family': 'Sharma family',
  'site.landing.preview.callLine': 'Voice call · 12 min',
  'site.landing.preview.callWhen': 'Today, 9:40 am',
  'site.landing.preview.listName': 'Sunday shopping',
  'site.landing.preview.listItem': 'Cardamom',
  'site.landing.preview.listDone': 'Basmati rice',
  'site.landing.preview.placeholder': 'Say something to everyone',
  'site.landing.preview.navChats': 'Chats',

  // Landing page: why Twinden
  'site.landing.why.eyebrow': 'Why Twinden',
  'site.landing.why.title': 'Made for the people you call family',
  'site.landing.why.intro':
    'Most messengers are built to grow a network or to sell advertising. Twinden is built for one thing: keeping a family close, privately.',
  'site.landing.why.private.title': 'Only your family can read it',
  'site.landing.why.private.body':
    'Messages, photos, voice notes, files, lists and documents are locked on your own devices before they’re sent. Our server keeps them, but can’t open them.',
  'site.landing.why.noAds.title': 'No ads. No tracking.',
  'site.landing.why.noAds.body':
    'Nothing in Twinden is built to sell your attention or your data. No ads, no analytics trackers, no selling, ever.',
  'site.landing.why.families.title': 'Built for families, not followers',
  'site.landing.why.families.body':
    'Each family gets its own space: one group with everyone, plus smaller groups and one-to-one chats. In more than one family? Switch between them.',
  'site.landing.why.passkeys.title': 'No passwords to forget',
  'site.landing.why.passkeys.body':
    'Sign in with your face, fingerprint or screen lock using passkeys. There’s no password to guess, phish or leak.',
  'site.landing.why.apps.title': 'The family’s things, in one place',
  'site.landing.why.apps.body':
    'Shared lists with who’s doing what and by when, documents in folders, saved links and starred messages, all encrypted like your chats.',
  'site.landing.why.calls.title': 'Calls, even on a bad signal',
  'site.landing.why.calls.body':
    'Voice and video calls for up to six people, encrypted between your devices. Messages written offline wait on your phone and go out when you’re back.',

  // Landing page: what we can and can't see
  'site.landing.see.eyebrow': 'Straight answers',
  'site.landing.see.title': 'What we can and can’t see',
  'site.landing.see.intro':
    'Privacy you can’t check isn’t privacy, so here is exactly where the line is.',
  'site.landing.see.cantTitle': 'We can’t see',
  'site.landing.see.cantMessages': 'What your messages say',
  'site.landing.see.cantMedia': 'Your photos, videos and voice notes',
  'site.landing.see.cantFiles': 'Your files and documents',
  'site.landing.see.cantApps': 'What’s on your lists and which links you save',
  'site.landing.see.cantCalls': 'Your calls’ audio and video',
  'site.landing.see.canTitle': 'We can see',
  'site.landing.see.canMembers': 'Who is in which family and chat',
  'site.landing.see.canTimes': 'When messages are sent, and who read them',
  'site.landing.see.canReactions':
    'Reactions and @mentions, so the right people are notified',
  'site.landing.see.canCalls': 'Who called whom, and for how long',
  'site.landing.see.note':
    'Encryption started in October 2026; chats and lists from before then stay as they were. The {link} has the details.',
  'site.landing.see.strength':
    'How strong the encryption is, and why we chose it: {link}.',

  // Landing page: pricing
  'site.landing.pricing.eyebrow': 'Free for everyone',
  'site.landing.pricing.title': 'Paid for by the families who use it',
  'site.landing.pricing.intro':
    'Twinden is free, with no limits and no premium tier. Here’s what it costs each month, and what families have paid towards it. If it’s useful to your family, chip in whatever you like. It doesn’t change anything about your access.',

  // Landing page: getting started
  // Why the name (owner's story, 2026-10-28).
  'site.landing.name.eyebrow': 'The name',
  'site.landing.name.title': 'Why “Twinden”?',
  'site.landing.name.body':
    'Twinden started in a one-room office with two desks. We called it our twin den: a small shared space where two people work side by side. That’s what we wanted for families too: one cosy room you share, wherever each of you is.',
  'site.landing.name.more': 'More about us',
  'site.landing.start.eyebrow': 'Getting started',
  'site.landing.start.title': 'Bring your family to Twinden',
  'site.landing.start.invitedTitle': 'Already invited?',
  'site.landing.start.invitedBody':
    'Scan the QR code someone in your family made for you, or sign in if you’ve joined before.',
  'site.landing.start.newTitle': 'Starting a family?',
  'site.landing.start.newBody':
    'Twinden is invite-only while it grows. Request an invitation and we’ll reply by email.',
  'site.landing.start.everywhereTitle': 'Works everywhere',
  'site.landing.start.everywhereBody':
    'Any up-to-date browser on a phone or computer. Install it to your home screen for notifications. iPhone and Android apps are on the way.',

  'site.landing.start.everywhereBodyApps':
    'Get the app for your iPhone or Android phone. On a computer, any up-to-date browser works.',
  // Pricing page
  'site.pricing.title': 'Pricing',
  'site.pricing.intro':
    '{name} is free for every family, with no limits, no ads and no premium tier. Below is what it costs each month, from servers to developer fees and the office, and what families have paid towards it. Pay any amount, once, whenever you like. It doesn’t change your access, and there is no subscription.',
  'site.pricing.razorpay': 'Contributions are handled by Razorpay.',

  // The costs card (landing and Pricing)
  'site.costs.coveredThrough': 'Covered through {month}',
  'site.costs.covered': 'This month is covered',
  'site.costs.progressLabel': 'How much of this month is paid for',
  'site.costs.short': '{amount} short this month ({percent}% paid for)',
  'site.costs.soon': 'This month’s costs will be published here soon.',
  'site.costs.estimated': 'Estimated',
  'site.costs.total': 'Costs this month',
  'site.costs.coming': 'Coming: {label}',
  'site.costs.paidByFamilies': 'Paid by families',
  'site.costs.carriedIn': 'Carried in',
  'site.costs.balance': 'Balance',
  'site.costs.recent': 'Recent months',
  'site.costs.month': 'Month',
  'site.costs.costs': 'Costs',
  'site.costs.paid': 'Paid',
  'site.costs.leftOver':
    'Anything left over is carried to next month and only ever pays for Twinden’s costs.',
  'site.costs.estimatesNote':
    ' These figures are estimates until the month’s bills are in.',
  // The admin panel's starting cost items (D110); shown translated when a
  // published month still uses them word for word.
  'site.costs.item.appServer': 'App server',
  'site.costs.item.appServerDetail':
    'Runs Twinden: the app, messages and calls signalling',
  'site.costs.item.database': 'Database',
  'site.costs.item.databaseDetail':
    'Accounts, chats and family apps, stored encrypted',
  'site.costs.item.storage': 'Storage and traffic',
  'site.costs.item.storageDetail': 'Encrypted photos, videos and files',
  'site.costs.item.domain': 'Domain',
  'site.costs.item.developerFees': 'Developer fees',
  'site.costs.item.office': 'Office',

  // About page
  'site.about.title': 'About us',
  'site.about.intro':
    'Twinden is a private place for families to talk, call, and keep their lists, documents and links together. It’s built for one thing only: keeping a family close, without anyone else listening in.',
  'site.about.standFor': 'What we stand for',
  'site.about.private.title': 'Private by design',
  'site.about.private.body':
    'Messages, photos, files, lists and documents are encrypted on your devices; our server stores them but can’t read them. We’re just as plain about what we can see, on the {home} and in the {privacy}.',
  'site.about.private.homeLink': 'home page',
  'site.about.noAds.title': 'No ads, no tracking',
  'site.about.noAds.body':
    'Twinden isn’t paid for by attention or data. There are no ads, no analytics trackers, and nothing is sold.',
  'site.about.open.title': 'Paid for openly',
  'site.about.open.body':
    'It’s free with no limits. Families who find it useful chip in, and what Twinden costs and what’s been paid are {link}.',
  'site.about.open.link': 'published every month',
  'site.about.families.title': 'Families first',
  'site.about.families.body':
    'Twinden is invite-only and built around families: one space each, with everyone together and smaller chats inside it. It isn’t trying to be a social network.',
  'site.about.why.title': 'Why we built it',
  'site.about.why.body':
    'Families today live across cities and countries: grandparents in one place, children in another, cousins abroad. We wanted one private place where everyone can stay close, without ads, tracking, or anyone else reading along.',
  'site.about.who.title': 'Who we are',
  'site.about.who.company':
    'Twinden is built and run by {company}, a software consultancy for small and midsize businesses. Paperdrop helps companies move off paper, forms and manual re-keying: mapping the process, automating what shouldn’t need a person, and leaving an audit trail on every step. Twinden is one of its own projects.',
  'site.about.who.visit': 'Visit {site}',
  'site.about.licenses': 'Open-source notices',
  'site.about.contact.title': 'Get in touch',
  'site.about.contact.body':
    'Questions, ideas or problems: write to {email}. Want Twinden for your family? Ask for an invitation.',

  // Request an invitation
  'site.requestInvite.title': 'Request an invitation',
  'site.requestInvite.intro':
    'Twinden is invite-only while it grows. Leave your name and email and we’ll get back to you. If someone in your family already uses Twinden, ask them to add you instead: it’s quicker.',
  'site.requestInvite.thanks': 'Thanks, we’ve got it',
  'site.requestInvite.sent':
    'We’ll write to you at {email}. In the meantime, here’s {link}.',
  'site.requestInvite.moreLink': 'more about Twinden',
  'site.requestInvite.name': 'Your name',
  'site.requestInvite.email': 'Email',
  'site.requestInvite.emailHint':
    'Only to reply to you. We delete requests 90 days after answering them.',
  'site.requestInvite.size': 'About how many people?',
  'site.requestInvite.size2to5': '2–5 people',
  'site.requestInvite.size6to10': '6–10 people',
  'site.requestInvite.size11to20': '11–20 people',
  'site.requestInvite.size20plus': 'More than 20',
  'site.requestInvite.sending': 'Sending…',
  'site.requestInvite.privacy': 'How we handle what you send is in the {link}.',

  // Run by families and Shape Twinden (M55, docs/run-by-families.md)
  'site.nav.ideas': 'Shape Twinden',
  'site.runBy.title': 'Run by the families who use it.',
  'site.runBy.label': 'This month’s costs and contributions',
  'site.runBy.costs': 'Costs {amount}',
  'site.runBy.received': 'Chipped in {amount}',
  'site.runBy.familiesOne': '{count} family chipped in',
  'site.runBy.familiesOther': '{count} families chipped in',
  'site.runBy.short': '{amount} short this month',
  'site.runBy.link': 'See the full costs',
  'site.costs.fromFamiliesOne': 'from {count} family',
  'site.costs.fromFamiliesOther': 'from {count} families',
  'site.ideas.title': 'Shape Twinden',
  'site.ideas.intro':
    'Ideas from the families who use Twinden. Vote for the ones you want: the most wanted are built first.',
  'site.ideas.signInLine': '{link} to post or vote.',
  'site.ideas.post': 'Share an idea',
  'site.ideas.empty': 'No ideas yet. Be the first to share one.',
  'site.ideas.emptySignedOut': 'No ideas yet.',
  'site.ideas.from': 'From a Twinden family · {date}',
  'site.ideas.status.planned': 'Planned',
  'site.ideas.status.building': 'Building',
  'site.ideas.status.done': 'Done',
  'site.ideas.status.notNow': 'Not now',
  'site.ideas.shipped': 'Shipped {month}',
  'site.ideas.mergedOne': 'Merged from {count} idea',
  'site.ideas.mergedOther': 'Merged from {count} ideas',
  'site.ideas.showDone': 'Show {count} done',
  'site.ideas.hideDone': 'Hide done',
  'site.ideas.showNotNow': 'Show {count} not now',
  'site.ideas.hideNotNow': 'Hide not now',
  'site.ideas.vote': 'Vote for “{title}”',
  'site.ideas.unvote': 'Take back your vote for “{title}”',
  'site.ideas.votesOne': '{count} vote',
  'site.ideas.votesOther': '{count} votes',
  'site.ideas.edit': 'Edit',
  'site.ideas.truncated': 'Showing the most wanted {count}',
  'site.ideas.loadError': 'Couldn’t load the ideas.',
  'site.ideas.voteFailed': 'Couldn’t save your vote',
  'site.ideas.posted': 'Thanks! Your idea is up.',
  'site.ideas.saved': 'Your idea is saved',
  'site.ideas.sheet.title': 'Share an idea',
  'site.ideas.sheet.editTitle': 'Edit your idea',
  'site.ideas.sheet.titleLabel': 'Title',
  'site.ideas.sheet.titlePlaceholder': 'What would make Twinden better?',
  'site.ideas.sheet.bodyLabel': 'Details (optional)',
  'site.ideas.sheet.bodyPlaceholder':
    'What it’s for, and who in your family would use it',
  'site.ideas.sheet.anonymous':
    'Shown as from a Twinden family: never your name or your family’s. You can edit it for 15 minutes.',
  'site.ideas.sheet.titleNeeded': 'Give your idea a title',
  'site.ideas.sheet.tooLong': 'Too long by {count}',
  'site.ideas.sheet.post': 'Post',
  'site.ideas.sheet.save': 'Save',
} as const;
